import React, { useState } from 'react';
import { Button, message, Modal } from 'antd';
import { adminSuspendInfluencer } from '../../../lib/Firebase/callables/admin';

const { confirm } = Modal;

const SuspendButton = ({ influencerUID, children, onSuspend }) => {
  const [loading, setLoading] = useState(false);

  function showConfirmation() {
    confirm({
      title: 'Are you sure you want to suspend this creator?',
      async onOk() {
        setLoading(true);
        try {
          await adminSuspendInfluencer(influencerUID);
          message.success('Influencer is now suspended');
        } catch (e) {
          message.error(e.message);
        }

        onSuspend(influencerUID);
        setLoading(false);
      },
    });
  }

  return (
    <Button
      loading={loading}
      onClick={() => showConfirmation()}
      type="default"
      className="action-reject"
      block
    >
      {children || 'Suspend'}
    </Button>
  );
};

export default SuspendButton;
